import React, { useRef } from 'react';
import type { FC } from 'react';
import classnames from 'classnames';

import { useIntersectionObserver } from 'usehooks-ts';
import styles from './countryList.desktop.module.css';

// Models:
import type { ICountryList } from './Models/country-list.model';

export const CountryListDesktop: FC<ICountryList> = (props) => {
  const {
    className,
    linkedCountryList,
    linkedCountryListTitle,
    trackCountryLinkClick,
  } = props;

  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, { freezeOnceVisible: true });
  const isVisible = !!entry?.isIntersecting || !linkedCountryListTitle;

  return (
    <div className={classnames(styles.countryList, className)} ref={ref}>
      {!!linkedCountryListTitle && (
        <h2 className={styles.title}>{linkedCountryListTitle}</h2>
      )}
      <div className={styles.listWrapper}>
        {linkedCountryList.map((country) => {
          const { text, link, iso2, onClick } = country;

          return (
            <div className={styles.countryWrapper} key={link}>
              {isVisible && (
                <div
                  className={classnames(
                    `lt-flag-${iso2?.toLowerCase() || 'us'}`,
                    `lt-flag`,
                  )}
                />
              )}

              <a
                className={styles.countryAnchor}
                onClick={() => {
                  trackCountryLinkClick(iso2);

                  if (!onClick) return;
                  onClick();
                }}
                href={link}
              >
                {text}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
